import * as React from "react"

function SvgComponent(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="currentColor"
            {...props}
        >
            <path d="M668-380l152-130 26 2q17 2 26.5 14t9.5 26q0 8-3 16t-11 14l-104 91 31 135q1 2 1 4.5v4.5q0 17-12 28.5T756-163q-5 0-10.5-1.5T735-169l-21-13-46-198zm-94-292l-42-98 9-22q5-12 15.5-18.5T578-817q11 0 21.5 6t15.5 18l55 130-96-9zM294-287l126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143zm-100 75l44-189L91-528q-8-6-10.5-14T78-558q0-14 9.5-26t26.5-14l194-17 75-178q5-12 15.5-18t21.5-6q11 0 21.5 6t15.5 18l75 178 194 17q17 2 26.5 14t9.5 26q0 8-2.5 16T749-528L602-401l44 189q1 3 1 9 0 17-12 28.5T607-163q-3 0-21-6L420-269 254-169q-5 3-10.5 4.5T233-163q-18 0-31-14.5t-8-34.5zm226-248z" />
        </svg>
    )
}

export default SvgComponent
